


















import { Component, Vue } from 'vue-property-decorator';
import GameBoard from '@/components/GameBoard.vue';
import { mapGetters, mapState } from 'vuex';
import { Action, State, Getter } from 'vuex-class';

@Component({
  components: {
  GameBoard,
  }
  })
export default class Home extends Vue {
  @State timeRemaining?: string;
  @State gameStarted?: boolean;
  @State capturing?: boolean;
  @State currentWord?: string;
  @State completedWords?: string[];
  @State score?: number;
  @Getter lastWordScore?: number;
  @Action startGame: any;

  get wordList(): string[] {
    return (this.completedWords) ? [...this.completedWords].reverse() : [];
  }
}
